/**
 * @generated SignedSource<<a03d359d7239b7dcdcb10986cc234124>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_PatternRedirector_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PatternRedirectorFragment_route"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_PatternRedirector_Query",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "patterns",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": "trips",
                "args": [
                  {
                    "kind": "Variable",
                    "name": "serviceDate",
                    "variableName": "date"
                  }
                ],
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "gtfsId",
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "413b8184a60d4f23f73feabda8a3dbc9",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_PatternRedirector_Query",
    "operationKind": "query",
    "text": "query routeRoutes_PatternRedirector_Query(\n  $routeId: String!\n  $date: String!\n) {\n  route(id: $routeId) {\n    ...PatternRedirectorFragment_route_19b1FI\n    id\n  }\n}\n\nfragment PatternRedirectorFragment_route_19b1FI on Route {\n  patterns {\n    code\n    trips: tripsForDate(serviceDate: $date) {\n      gtfsId\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

node.hash = "b019d3cb9d6bf81a57c6d04cb52e8ed4";

export default node;
